import PageViewed from './PageViewed';

const operations: { [key: string]: any } = {
    PageViewed: PageViewed,
};

export default operations;
